module.exports = __webpack_public_path__ + "img/電気回路_2_10_1.06c14841.png";